import { RoutePaths } from '../../constants';
import { getActiveCategories } from '../../data/categories';

const validCategoryIds = new Set(getActiveCategories().map(category => category.id));

export const validateCategories = (categories: string[]): string[] => {
    return categories.filter(category => validCategoryIds.has(category));
};

export const parseCategoriesFromUrl = (pathCategory?: string, queryCategories?: string): string[] => {
    const categories: string[] = [];

    if (pathCategory) {
        categories.push(pathCategory);
    }

    if (queryCategories) {
        categories.push(...queryCategories.split('_'));
    }

    return validateCategories(categories);
};

/**
 * Формирует URL путь из массива категорий
 * Схема: [] → '/', ['cat1'] → '/c/cat1', ['cat1', 'cat2', 'cat3'] → '/c/cat1?categories=cat2_cat3'
 *
 * @param {String[]} categories - Массив ID категорий
 * @returns {String} URL путь для навигации
 */
export const buildCategoriesPath = (categories: string[]): string => {
    const validCategories = validateCategories(categories);

    if (validCategories.length === 0) {
        return RoutePaths.Main;
    }

    if (validCategories.length === 1) {
        return `${RoutePaths.Category}/${validCategories[0]}`;
    }

    const [firstCategory, ...restCategories] = validCategories;
    const queryString = restCategories.join('_');

    return `${RoutePaths.Category}/${firstCategory}?categories=${queryString}`;
};
